import React from 'react';
import HeroSection from './HeroSection';
import classNames from 'classnames';
import logo from '../assets/images/logo.svg';
import { Link } from 'react-router-dom';
import { Disclosure } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const menu = [
  {
    name: 'Home',
    href: '/',
    id: 'home',
  },
  {
    name: 'About Us',
    href: '#aboutus',
    id: 'aboutus',
  },
  {
    name: 'Tokenomics',
    href: '#tokenomics',
    id: 'tokenomics',
  },
  // {
  //   name: 'Roadmap',
  //   href: '#roadmap',
  //   id: 'roadmap',
  // },
];

export default function Header({ setOpen, headerOpen }) {
  return (
    <div className=" header-image overflow-x-hidden text-white bg-opacity-20 ">
      <div className="bg-header bg-opacity-25">
        <header className="max-w-[1200px] mx-auto px-6 ">
          <div
            className={`mx-4 py-5 sm:py-5 md:py-10 lg:pt-20 sm:mx-4 md:mx-4 lg:mx-6 2xl:mx-0 ${headerOpen && 'h-screen overflow-hidden'
              }`}
          >
            <Disclosure as="nav" className="">
              {({ open, close }) => {
                setOpen(open);
                return (
                  <>
                    <div className="flex justify-between">
                      <div
                        className={`flex animate__animated animate__lightSpeedInLeft  animate__delay-1s ${open ? 'hidden' : 'block'
                          }`}
                      >
                        <div className="flex lg:flex-1">
                          <Link to="/" className="-m-1.5 p-1.5">
                            <div className="flex gap-[10px]">
                              <img className="h-[46px] w-auto" src={logo} alt="Cops Dorkl" />
                              <div className="font-Caveat text-4xl flex items-center">CopsDorkL</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="flex items-center animate__animated animate__bounceInDown animate__delay-1s text-base tracking-wide">
                        <div className="hidden md:ml-6 md:flex md:items-center">
                          <div className="hidden md:-my-px md:ml-6 md:flex md:space-x-14 font-Caveat text-lg font-bold">
                            {menu.map((item) => (
                              <a
                                key={item.name}
                                href={item.href}
                                className={({ isActive }) =>
                                  classNames(
                                    isActive
                                      ? 'border-aquamarine'
                                      : 'hover:border-aquamarine border-transparent',
                                    '   capitalize leading-5 tracking-[0.016em] text-nobel cursor-pointer'
                                  )
                                }
                              >
                                {item.name}
                              </a>
                            ))}
                          </div>
                          <div className="hidden md:-my-px md:ml-12 md:flex md:space-x-8 animate__animated animate__backInRight">
                            <a
                              href="https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=0x847feC068a092247DD0A6a83a7E2cD791bfFb156"
                              target="_blank"
                            >
                              <button className="font-Salsa button-bg text-white text-base leading-5 font-normal py-3 px-8 rounded-[50px] ">
                                Get $CODL
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="md:hidden items-center">
                        <div className="-mr-2 flex items-center md:hidden">
                          <Disclosure.Button className=" inline-flex items-center justify-center rounded-md p-2 focus:outline-none focus:ring-0 focus:ring-indigo-500 focus:ring-offset-0">
                            <span className="sr-only">Open main menu</span>
                            {open ? (
                              <XMarkIcon
                                className="block h-6 w-6 focus:ring-offset-0"
                                aria-hidden="true"
                              />
                            ) : (
                              <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                            )}
                          </Disclosure.Button>
                        </div>
                      </div>
                    </div>

                    <Disclosure.Panel className="bg-header-mobile animate__animated animate__slideInDown animate__faster absolute left-0 right-0 top-16 flex h-screen flex-col justify-evenly lg:hidden">
                      <div className="absolute -top-[44px] left-4">
                        <div className="flex lg:flex-1">
                          <Link to="/" className="-m-1.5 p-1.5">
                            <div className="flex gap-[10px]">
                              <img className="h-[46px] w-auto" src={logo} alt="Cops Pepe" />
                              <div className="font-Caveat text-4xl flex items-center">CopsDorkL</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="grid gap-5 font-Caveat space-y-1 pt-2 pb-3 text-2xl font-medium text-center animate__animated animate__bounceInDown animate__delay-1s">
                        {menu.map((item) => (
                          <a
                            key={item.name}
                            href={item.href}
                            onClick={() => close()}
                            className={({ isActive }) =>
                              classNames(
                                isActive
                                  ? ''
                                  : 'hover:bg-aquamarine-400 border-transparent text-nobel hover:border-gray-300 hover:text-gray-800',
                                'block py-2 pl-3 pr-4 '
                              )
                            }
                          >
                            {' '}
                            {item.name}
                          </a>
                        ))}
                      </div>

                      <div className="flex justify-center animate__animated animate__backInDown">
                        <a
                          href="https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=0x847feC068a092247DD0A6a83a7E2cD791bfFb156"
                          target="_blank"
                        >
                          <button className="font-Salsa button-bg text-white text-base leading-5 font-normal py-3 px-8 rounded-[50px]">
                            Get $CODL
                          </button>
                        </a>
                      </div>
                    </Disclosure.Panel>
                  </>
                );
              }}
            </Disclosure>
          </div>
        </header>
        {!headerOpen && <HeroSection />}
      </div>
    </div>
  );
}
